export const iconFontAwesomeHumanitarianPersonArrowDownToLine = (
	<i className="fa-solid fa-person-arrow-down-to-line"></i>
);
